import {
  REQUEST_FAILED,
  REQUEST_GET_USER_INBOX,
  REFRESH_USER_INBOX,
  REQUEST_USER_CONVERSATION,
  REFRESH_USER_CONVERSATION,
  REQUEST_SET_MESSAGE_TO_ARCHIVED,
  REQUEST_SET_MESSAGE_TO_VIEWED,
  SET_MESSAGE_ARCHIVED,
  SET_MESSAGE_VIEWED,
  DECREMENT_INBOX_COUNT,
} from "../actions/messages";

import { LOG_OUT } from "../actions/user";

import _ from "lodash";

const defaultState = {
  isLoading: false,
  inbox: [],
  messageList: [],
  selectedMessageContactId: -1,
  selectedMessageContactName: "",
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });
    case REQUEST_GET_USER_INBOX:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_USER_INBOX:
      return Object.assign({}, state, {
        isLoading: false,
        inbox: action.inbox,
      });
    case REQUEST_USER_CONVERSATION:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_SET_MESSAGE_TO_ARCHIVED:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_SET_MESSAGE_TO_VIEWED:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case SET_MESSAGE_ARCHIVED:
      const updatedList = state.messageList.map((m) => {
        if (m.messageId === action.messageId) {
          m.archived = true;
        }
        return m;
      });
      return Object.assign({}, state, {
        isLoading: false,
        messageList: updatedList,
      });
    case SET_MESSAGE_VIEWED: {
      const updatedList = state.messageList.map((m) => {
        if (m.messageId === action.messageId) {
          m.viewed = true;
        }
        return m;
      });
      return Object.assign({}, state, {
        isLoading: false,
        messageList: updatedList,
      });
    }
    case DECREMENT_INBOX_COUNT:
      const updatedInbox = state.inbox.map((inboxItem) => {
        if (inboxItem.userId === action.userId) {
          inboxItem.unreadMsgCount = inboxItem.unreadMsgCount - 1;
        }
        return inboxItem;
      });
      return Object.assign({}, state, {
        isLoading: false,
        inbox: updatedInbox,
      });

    case REFRESH_USER_CONVERSATION:
      return Object.assign({}, state, {
        isLoading: false,
        selectedMessageContactId: action.selectedMessageContactId,
        selectedMessageContactName: action.selectedMessageContactName,
        messageList: action.messageList,
      });
    case LOG_OUT:
      return {
        isLoading: false,
        inbox: [],
        messageList: [],
        selectedMessageContactId: -1,
        selectedMessageContactName: "",
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/messages.js